<script setup>
defineProps({
    image: String,
    imageAlt: String,
    name: String,
    title: String,
});
</script>

<template>
    <figure class="mt-12 border-l border-gray-200 dark:border-gray-700 pl-8">
        <blockquote class="*:text-base/7!">
            <!-- Testimonial Slot -->
            <slot></slot>
        </blockquote>
        <figcaption class="mt-6 flex items-center gap-x-4 text-sm/6">
            <img
                :src="image"
                :alt="imageAlt"
                class="size-10 sm:size-6 flex-none aspect-square rounded-full"
            />
            <div
                class="flex flex-col sm:flex-row sm:items-center sm:gap-1 text-accent"
            >
                <span class="font-semibold text-p text-sm!">{{ name }}</span>
                <span class="max-sm:hidden">–</span>
                <span>{{ title }}</span>
            </div>
        </figcaption>
    </figure>
</template>
